module.exports = __webpack_public_path__ + "static/client_2_after-8f454803c405f6300f570bb80301f116.jpg";